module.exports = __webpack_public_path__ + "img/BR_Stab.c8c6aba1.svg";